module.exports = __webpack_public_path__ + "0590abfab50c58b19845d45a039c430b.woff";


//////////////////
// WEBPACK FOOTER
// ./src/style/fonts/GT-Walsheim-Pro-Regular.woff
// module id = 402
// module chunks = 0